import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';

import { TooltipIconButton } from '@paragon/client-tools';

import { showDownloadProductionArtifactsDialog } from '../../actions/dialogActions';
import { DownloadProductionPackageDialogProps } from '../dialogs/DownloadProductionPackageDialog';
import { useAppDispatch } from '../hooks';

export function DownloadProductionPackageButton(props: DownloadProductionPackageDialogProps) {
  const { bundleGuids } = props;
  const dispatch = useAppDispatch();

  return (
    <TooltipIconButton
      title={
        bundleGuids.length === 0 ? 'Select bundles to download a production package' : 'Download production package'
      }
      onClick={() => void dispatch(showDownloadProductionArtifactsDialog(props))}
      disabled={bundleGuids.length === 0}
    >
      <DownloadIcon />
    </TooltipIconButton>
  );
}
